import OrderIdentifiersGrid from './OrderIdentifiersGrid';

const IdentifiersSection = ({ type, orderDetails }) => (
  <>
    {type !== 'detailsSimIpb' &&
      type !== 'DetailsFailedTransactions' &&
      type !== 'DetailsPurchaseOrdersIpb' && (
        <OrderIdentifiersGrid
          type={type}
          title={
            type === 'detailsHistoryPrepaid'
              ? 'Detalles de la Respuesta'
              : type === 'detailsSimIpb'
                ? 'Identificadores'
                : type === 'detailPurchase' || type === 'AiraloDetails'
                  ? 'Forma de Pago'
                  : 'Identificadores'
          }
          orderDetails={orderDetails}
        />
      )}
  </>
);

export default IdentifiersSection;
